<template>
  <div class="photoMainPage">
    <v-form
      v-model="valid"
      validation
      style="display: flex;justify-content: flex-start;flex-direction: column"
    >
      <div class="input-image">
        <v-file-input
          v-model="webImgPath"
          class="input"
          chips
          required
          placeholder="عکس وب مورد نظر خود را وارد کنید."
          accept="image/png, image/jpeg, image/bmp"
          prepend-icon="mdi-camera"
          v-on:change="showWebImage($event)"
          v-on:click:clear="deleteWebImage"
        ></v-file-input>
        <v-img style="max-width: 200px" width="200" height="150" :src="imageUserWeb"></v-img>
      </div>
      <div class="input-image">
      <v-file-input
        v-model="mobileImgPath"
        class="input"
        chips
        required
        placeholder="عکس موبایل مورد نظر خود را وارد کنید."
        accept="image/png, image/jpeg, image/bmp"
        prepend-icon="mdi-camera"
        v-on:change="showMobileImage($event)"
        v-on:click:clear="deleteMobileImage"
      ></v-file-input>
      <v-img style="max-width: 200px" width="200" height="150" :src="imageUserMobile"></v-img>

      </div>
      <v-btn

        @click="sendData"
        class="button"
        :disabled="!valid"
        v-show="!isEdit"
        :loading="loadingSend"
      >
        فرستادن
      </v-btn>
      <v-btn

        @click="editData(originalPhoto[0].id)"
        class="button"
        :disabled="!valid"
        v-show="isEdit"
        :loading="loadingSend"
      >
        ویرایش
      </v-btn>
    </v-form>
    <div v-if="isEdit" class="images" v-for="item in originalPhoto">
      <div class="webPage">
        <p style="font-weight: bold;font-size:1.5rem">عکس وب:</p>
        <v-img lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" width="300" height="200" :src="baseUrl+item.webImgPath+ '?'+ dates">
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
      <div class="mobilePage">
        <p style="font-weight: bold;font-size:1.5rem">عکس موبایل:</p>
         <v-img lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" width="300" height="200" :src="baseUrl+item.mobileImgPath+ '?'+ dates">
           <template v-slot:placeholder>
             <v-row
               class="fill-height ma-0"
               align="center"
               justify="center"
             >
               <v-progress-circular
                 indeterminate
                 color="grey lighten-5"
               ></v-progress-circular>
             </v-row>
           </template>
         </v-img>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import { setPhoto,putPhoto} from "../../../api/mainpage/photo";
  import {toBase64} from "../../../plugins/toBase64";

    export default {
        name: "MainPagePicture",
        data:()=>({
          baseUrl:'',
          mobileImgPath:[],
          webImgPath:[],
          loadingSend:false,
          dates:'',
          valid:true,
          imageUserWeb:'',
          imageUserMobile:'',
          isEdit: false
        }),
       methods:{
         showWebImage(e){
           if(e) {
             this.imageUserWeb = URL.createObjectURL(e)
           }
         },
         deleteWebImage()
         {
           this.imageUserWeb = ''
         },
         showMobileImage(e){
           if(e) {
             this.imageUserMobile = URL.createObjectURL(e)
           }
         },
         deleteMobileImage()
         {
           this.imageUserMobile = ''
         },
         async sendData(){
         this.loadingSend = true
         let mobile =    await toBase64(this.mobileImgPath)
         let web =    await toBase64(this.webImgPath)
                await setPhoto({
                  mobileImgPath:mobile,
                  webImgPath:web
                }).then(()=>{
                  this.getPhotoReq()
                  this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
                  this.dates=new Date()
                  this.webImgPath=[]
                  this.mobileImgPath=[]
                }).catch(()=>{
                  this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
                })
           this.loadingSend = false
          },
        async editData(id){
           this.loadingSend = true
           let mobile =   await toBase64(this.mobileImgPath)
           let web =  await toBase64(this.webImgPath)
               await  putPhoto({
                 id:id,
                 mobileImgPath:mobile,
                 webImgPath:web
               },id).then(()=>{
                 this.deleteWebImage()
                 this.deleteMobileImage()
                 this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
                 this.dates = new Date()
                 this.mobileImgPath=[]
                 this.webImgPath=[]
                 this.getPhotoReq()
               }).catch(()=>{
                 this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
               })
          this.loadingSend = false
          this.mobileImgPath = []
          this.webImgPath = []
         },
         ...mapActions({
           getPhotoReq:'MainPagePhoto/fetchPhoto',
           snackBarAction:'snackBar/snackBarAction',
           setLoading : 'setLoading'

         }),
       },
      computed: {
        ...mapGetters({
          originalPhoto: 'MainPagePhoto/get_photo',
        })
      },
     async  mounted() {
          this.setLoading(true)
          this.dates = new Date()
          this.baseUrl = process.env.VUE_APP_BASE_URL
           await  this.getPhotoReq().then(()=>{
             this.isEdit = this.originalPhoto.length !== 0;
         })
          this.setLoading(false)

      }
    }
</script>

<style scoped>
   .image{
     display: flex;
   }
   .button{
     align-self: flex-end;
     margin-top: 1rem;
   }
   .input-image{
     display: flex;
     justify-content: space-between;
     align-items: center;
     margin-bottom: 2rem;
   }
   .input{
     max-width: 300px;
   }
   .images{
     display: flex;
     flex-wrap: wrap;
     justify-content: space-evenly;
     position: relative;
     margin-bottom: 1rem;
     margin-top: 3rem;
   }
</style>
